export enum DbEnum {
    QE_Dev_Config = 1,
    QE_DEV_SQL_DB = 2
}
